import { createSlice } from "@reduxjs/toolkit";
// eslint-disable-next-line no-duplicate-imports
import type { PayloadAction } from "@reduxjs/toolkit";

export const CREDIT_SUMMARY_AGREEMENT_MODAL = "CreditSummaryAgreementModal";
export const CREDIT_SUMMARY_PAYMENT_CERT_MODAL = "CreditSummaryPaymentCertModal";
export const CREDIT_SUMMARY_DEBT_CERT_MODAL = "CreditSummaryDebtCertModal";
export const CREDIT_SUMMARY_REFUND_PROOF_MODAL = "CreditSummaryRefundProofModal";

export type FileModalContent = {
  modalId: string;
  title?: string;
  agreement?: string;
  downloadUrl?: string;
  loanId?: number;
  documentName?: string;
};

interface CreditSummaryState {
  loanId?: number,
  directTransferRecords?: any,
  fileModalContent?: FileModalContent | null,
  fileModalDownloadInProgress?: boolean
}

const initialState: CreditSummaryState = {
};

const creditSummarySlice = createSlice({
  name: "creditSummary",
  initialState,
  reducers: {
    getDirectTransferPaymentRecordsRequest(state, action) {
      return state;
    },
    getDirectTransferPaymentRecordsSuccess(state, action: PayloadAction<any>) {
      state.loanId = action.payload.loanId;
      state.directTransferRecords = action.payload.directTransferRecords;
    },
    openFileModal(state, action: PayloadAction<FileModalContent>) {
      state.fileModalContent = action.payload;
    },
    fetchAgreementStart(state, action: PayloadAction<any>) {
      state.fileModalContent = { modalId: CREDIT_SUMMARY_AGREEMENT_MODAL };
    },
    fetchAgreementSuccess(state, action: PayloadAction<Partial<FileModalContent>>) {
      state.fileModalContent = {
        ...state.fileModalContent,
        modalId: CREDIT_SUMMARY_AGREEMENT_MODAL,
        ...action.payload
      };
    },
    closeFileModal(state) {
      state.fileModalContent = null;
    },
    downloadFileModal(state) {
      state.fileModalDownloadInProgress = true;
    },
    downloadFileModalSuccess(state) {
      state.fileModalDownloadInProgress = false;
    },
    printFileModal(state) {
      return state;
    },
    destroy() {
      return initialState;
    }
  }
});


export default creditSummarySlice.reducer;
export const {
  getDirectTransferPaymentRecordsRequest,
  getDirectTransferPaymentRecordsSuccess,
  openFileModal,
  fetchAgreementStart,
  fetchAgreementSuccess,
  closeFileModal,
  downloadFileModal,
  downloadFileModalSuccess,
  printFileModal,
  destroy
} = creditSummarySlice.actions;
export const creditSummaryActions = creditSummarySlice.actions;
